let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("98Bif")).then(() => parcelRequire('8qbJw'));